import { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
import PeriodEducationalContent from "./PeriodEducationalContent";
const TITLE = "Calculatrice de cycle menstruel - Calculer la date des prochaines règles avec précision";
const DESCRIPTION =
  "Calculatrice de cycle menstruel - Calculer la date des prochaines règles avec précision pour obtenir des estimations utiles en sante feminine et suivi du cycle. Entrez vos informations et recevez des resultats rapides pour mieux planifier.";
const KEYWORDS =
  "de cycle menstruel r la date des prochaines règles avec précision, calculatrice de cycle menstruel r la date des prochaines règles avec précision, calcul en ligne, sante feminine, cycle, grossesse, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/period/";

const GREGORIAN_MONTHS = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];
function PeriodCalculator() {
  const [dateInput, setDateInput] = useState({
    day: new Date().getDate(),
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear()
  });

  const [periodLength, setPeriodLength] = useState(5);
  const [cycleLength, setCycleLength] = useState(28);
  const [lastPeriodError, setLastPeriodError] = useState("");
  const [periodLengthError, setPeriodLengthError] = useState("");
  const [cycleLengthError, setCycleLengthError] = useState("");
  const [result, setResult] = useState(null);

  const addDays = (date, days) => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  };

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const handleDropdownChange = (e) => {
    const { name, value } = e.target;
    const newDateInput = { ...dateInput, [name]: value };
    setDateInput(newDateInput);

    const selectedDate = new Date(newDateInput.year, newDateInput.month - 1, newDateInput.day);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (selectedDate > today) {
      setLastPeriodError("La date doit être dans le passé");
    } else {
      const diffTime = Math.abs(today - selectedDate);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      if (diffDays > 90) {
        setLastPeriodError("La date semble trop éloignée dans le passé");
      } else {
        setLastPeriodError("");
      }
    }
  };

  const handlePeriodLengthChange = (event) => {
    const value = event.target.value;
    if (value !== "") {
      const parsedValue = parseInt(value);
      if (!isNaN(parsedValue) && parsedValue >= 1 && parsedValue <= 10) {
        setPeriodLength(parsedValue);
        setPeriodLengthError("");
      } else {
        setPeriodLength(value);
        if (isNaN(parsedValue)) {
          setPeriodLengthError("Veuillez entrer un nombre valide");
        } else if (parsedValue < 1) {
          setPeriodLengthError("La durée des règles doit être d'au moins un jour");
        } else if (parsedValue > 10) {
          setPeriodLengthError("La durée des règles ne doit pas dépasser 10 jours");
        }
      }
    } else {
      setPeriodLength("");
      setPeriodLengthError("");
    }
  };

  const handleCycleLengthChange = (event) => {
    const value = event.target.value;
    if (value !== "") {
      const parsedValue = parseInt(value);
      if (!isNaN(parsedValue) && parsedValue >= 21 && parsedValue <= 35) {
        setCycleLength(parsedValue);
        setCycleLengthError("");
      } else {
        setCycleLength(value);
        if (isNaN(parsedValue)) {
          setCycleLengthError("Veuillez entrer un nombre valide");
        } else if (parsedValue < 21) {
          setCycleLengthError("La durée du cycle doit être d'au moins 21 jours");
        } else if (parsedValue > 35) {
          setCycleLengthError("La durée du cycle ne doit pas dépasser 35 jours");
        }
      }
    } else {
      setCycleLength("");
      setCycleLengthError("");
    }
  };

  const handleReset = () => {
    setDateInput({
      day: new Date().getDate(),
      month: new Date().getMonth() + 1,
      year: new Date().getFullYear()
    });
    setPeriodLength(5);
    setCycleLength(28);
    setLastPeriodError("");
    setPeriodLengthError("");
    setCycleLengthError("");
    setResult(null);
  };

  const calculatePeriod = (e) => {
    e.preventDefault();
    const startDate = new Date(dateInput.year, dateInput.month - 1, dateInput.day);

    if (isNaN(startDate.getTime()) || !periodLength || !cycleLength || lastPeriodError) {
      return;
    }

    const periods = [];
    for (let i = 0; i < 12; i++) {
      const periodStart = addDays(startDate, cycleLength * i);
      const periodEnd = addDays(periodStart, periodLength - 1);
      const ovulationDay = addDays(periodStart, cycleLength - 14);
      const ovulationStart = addDays(ovulationDay, -2);
      const ovulationEnd = addDays(ovulationDay, 2);
      periods.push({
        cycleNumber: i + 1,
        periodStart: formatDate(periodStart),
        periodEnd: formatDate(periodEnd),
        ovulationStart: formatDate(ovulationStart),
        ovulationEnd: formatDate(ovulationEnd),
        ovulationDay: formatDate(ovulationDay),
      });
    }
    setResult({
      periods: periods,
      cycleLength: cycleLength,
      periodLength: periodLength,
    });
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ padding: "15px", borderRadius: "12px" }}
          >
            <h1 style={{ fontSize: "22px", margin: 0 }}>{TITLE}</h1>
          </div>
          <div className="border border-light mt-3 p-3 bg-white shadow-sm">
            <div className="mb-4">
              <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
                <strong>Calculatrice de cycle menstruel</strong> est un outil gratuit et précis 
                pour calculer <strong>la date de vos prochaines règles</strong> et 
                <strong> les jours d'ovulation</strong> pendant les 12 prochains mois. 
                Tout ce que vous devez faire est d'entrer la date du premier jour de vos 
                dernières règles et la durée moyenne de votre cycle pour obtenir un 
                calendrier complet montrant les dates des <strong>prochains cycles</strong> 
                et <strong>les périodes de fertilité</strong> avec précision.
              </p>
            </div>
            <hr />
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-6 calculatorStyle">
                <div className="p-3 mb-3 bg-success text-white text-center rounded">
                  <h2 style={{ fontSize: "18px", margin: 0 }}>
                    Calculez vos prochaines règles
                  </h2>
                </div>
                <form onSubmit={calculatePeriod}>
                  <div className="form-group mb-3">
                    <label>
                      <strong>Premier jour de vos dernières règles:</strong>
                    </label>
                    <div className="d-flex gap-2">
                      <select style={{width:'100px'}} className="form-control" name="day" value={dateInput.day} onChange={handleDropdownChange}>
                        {Array.from({ length: 31 }, (_, i) => i + 1).map(d => <option key={d} value={d}>{d}</option>)}
                      </select>
                      <select style={{width:'100%'}} className="form-control" name="month" value={dateInput.month} onChange={handleDropdownChange}>
                        {GREGORIAN_MONTHS.map((m, i) => <option key={i + 1} value={i + 1}>{i + 1} - {m}</option>)}
                      </select>
                      <select style={{width:'100px'}} className="form-control" name="year" value={dateInput.year} onChange={handleDropdownChange}>
                        {Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i).map(y => <option key={y} value={y}>{y}</option>)}
                      </select>
                    </div>
                    {lastPeriodError && <div className="text-danger mt-1" style={{ fontSize: "14px" }}>{lastPeriodError}</div>}
                  </div>

                  <div className="form-group mb-3">
                    <label htmlFor="periodLength">
                      <strong>Durée des règles (combien de jours?):</strong>
                    </label>
                    <div className="d-flex align-items-center">
                      <input id="periodLength" type="number" className="form-control" value={periodLength} onChange={handlePeriodLengthChange} min="1" max="10" required style={{ maxWidth: "150px" }} />
                      <span style={{ marginLeft: "10px", padding: "8px 15px", border: "1px solid #ced4da", borderRadius: "4px", backgroundColor: "#f9f9f9" }}>jours</span>
                    </div>
                    {periodLengthError && <div className="text-danger mt-1" style={{ fontSize: "14px" }}>{periodLengthError}</div>}
                    <small className="form-text text-muted mt-1">Moyenne normale: 3-7 jours</small>
                  </div>

                  <div className="form-group mb-4">
                    <label htmlFor="cycleLength">
                      <strong>Durée moyenne du cycle (temps entre les cycles):</strong>
                    </label>
                    <div className="d-flex align-items-center">
                      <input id="cycleLength" type="number" className="form-control" value={cycleLength} onChange={handleCycleLengthChange} min="21" max="35" required style={{ maxWidth: "150px" }} />
                      <span style={{ marginLeft: "10px", padding: "8px 15px", border: "1px solid #ced4da", borderRadius: "4px", backgroundColor: "#f9f9f9" }}>jours</span>
                    </div>
                    {cycleLengthError && <div className="text-danger mt-1" style={{ fontSize: "14px" }}>{cycleLengthError}</div>}
                    <small className="form-text text-muted mt-1">Moyenne normale: 28 jours (varie de 21-35 jours)</small>
                  </div>

                  <hr />
                  <div className="d-flex gap-2">
                    <button type="submit" className="btn bg-success text-white" style={{ fontSize: "16px", padding: "10px 30px" }}>Calculer</button>
                    <button type="button" className="btn btn-secondary" onClick={handleReset} style={{ fontSize: "16px", padding: "10px 30px", marginLeft: "10px" }}>Réinitialiser</button>
                  </div>
                </form>
              </div>
              <div className="col-sm-12 col-md-6">
                {result && (
                  <div className="calculatorStyle">
                    <div className="p-3 mb-3 bg-success text-white text-center rounded">
                      <h3 style={{ fontSize: "18px", margin: 0 }}>
                        Calendrier menstruel - 12 prochains mois
                      </h3>
                    </div>
                    <div
                      className="alert alert-info"
                      style={{
                        fontSize: "14px",
                        maxHeight: "500px",
                        overflowY: "auto",
                      }}
                    >
                      {result.periods.map((period, index) => (
                        <div
                          key={index}
                          style={{
                            marginBottom: "20px",
                            padding: "15px",
                            backgroundColor:
                              index % 2 === 0 ? "#f8f9fa" : "#ffffff",
                            borderRadius: "8px",
                            border: "1px solid #dee2e6",
                          }}
                        >
                          <h4
                            style={{
                              fontSize: "16px",
                              color: "#198754",
                              marginBottom: "10px",
                            }}
                          >
                            <strong>Cycle n°{period.cycleNumber}</strong>
                          </h4>
                          <div style={{ lineHeight: "1.8" }}>
                            <div style={{ marginBottom: "5px" }}>
                              <strong>Période des règles:</strong>{" "}
                              {period.periodStart} - {period.periodEnd}
                            </div>
                            <div style={{ marginBottom: "5px" }}>
                              <strong>Jour d'ovulation:</strong>{" "}
                              {period.ovulationDay}
                            </div>
                            <div style={{ color: "#0d6efd", fontWeight: "500" }}>
                              <strong>Période fertile:</strong>{" "}
                              {period.ovulationStart} - {period.ovulationEnd}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div
              className="alert alert-info"
              style={{ fontSize: "15px", lineHeight: "1.8" }}
            >
              <strong>💡 Remarque importante:</strong> Ces résultats sont estimatifs 
              et supposent que votre cycle est régulier. Pour des informations précises 
              sur la fertilité et l'ovulation, consultez un médecin ou utilisez des tests 
              d'ovulation à domicile.
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
            </div>
          </div>
        </div>
        <div className="col-sm-12 col-md-4">
          <SecondAds />
          <br />
          <MainCalculatorsList />
        </div>
      </div>
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>Qu'est-ce que le cycle menstruel ?</h3>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  Le <strong>cycle menstruel</strong> est un processus biologique mensuel chez les femmes 
                  qui prépare le corps à la possibilité de grossesse. Il est contrôlé par des hormones 
                  et dure généralement entre <strong>21 et 35 jours</strong>, avec une moyenne de
                  <strong> 28 jours</strong>.
                </p>
                <h4 style={{ fontSize: "15px", marginTop: "15px" }}>Ce que vous devez savoir:</h4>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>Le cycle commence normalement entre <strong>12 et 15 ans</strong> (ménarche)</li>
                  <li>Il continue jusqu'à la <strong>ménopause</strong> (généralement autour de 50-51 ans)</li>
                  <li>Chaque femme a un cycle qui lui est <strong>personnel et unique</strong></li>
                  <li>Un cycle régulier est généralement un <strong>signe de bonne santé</strong></li>
                  <li>Les variations cycliques sont <strong>complètement normales</strong></li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>Les phases du cycle menstruel</h3>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  Le cycle menstruel se divise généralement en <strong>quatre phases principales</strong>:
                </p>
                <h4 style={{ fontSize: "15px", marginTop: "15px", color: "#e74c3c" }}>
                  <strong>1. Phase menstruelle (Menstruation)</strong>
                </h4>
                <ul style={{ lineHeight: "1.8" }}>
                  <li><strong>Durée:</strong> 3 à 7 jours (en moyenne 5 jours)</li>
                  <li><strong>Qu'est-ce qui se passe:</strong> La paroi de l'utérus s'écoule</li>
                  <li><strong>Symptômes courants:</strong> Saignements, crampes, inconfort</li>
                  <li><strong>Conseil:</strong> Restez hydratée et utilisez des protections hygiéniques</li>
                </ul>

                <h4 style={{ fontSize: "15px", marginTop: "15px", color: "#3498db" }}>
                  <strong>2. Phase folliculaire (Phase d'œstrogène)</strong>
                </h4>
                <ul style={{ lineHeight: "1.8" }}>
                  <li><strong>Durée:</strong> Environ 13 jours</li>
                  <li><strong>Qu'est-ce qui se passe:</strong> L'hypophyse libère des hormones pour 
                  stimuler les ovaires</li>
                  <li><strong>Symptômes:</strong> Augmentation d'énergie et d'humeur positive</li>
                  <li><strong>Conseil:</strong> Excellente période pour l'exercice intense</li>
                </ul>

                <h4 style={{ fontSize: "15px", marginTop: "15px", color: "#2ecc71" }}>
                  <strong>3. Phase d'ovulation</strong>
                </h4>
                <ul style={{ lineHeight: "1.8" }}>
                  <li><strong>Durée:</strong> 12 à 24 heures</li>
                  <li><strong>Qu'est-ce qui se passe:</strong> L'ovule est libéré par l'ovaire</li>
                  <li><strong>Fertilité:</strong> <strong>PERIODE LA PLUS FERTILE</strong> pour concevoir</li>
                  <li><strong>Conseil:</strong> Si vous planifiez une grossesse, c'est le meilleur moment</li>
                </ul>

                <h4 style={{ fontSize: "15px", marginTop: "15px", color: "#f39c12" }}>
                  <strong>4. Phase lutéale (Phase de progestérone)</strong>
                </h4>
                <ul style={{ lineHeight: "1.8" }}>
                  <li><strong>Durée:</strong> Environ 14 jours</li>
                  <li><strong>Qu'est-ce qui se passe:</strong> Les niveaux de progestérone augmentent</li>
                  <li><strong>Symptômes possibles:</strong> Syndrome prémenstruel (SPM): fatigue, 
                  irritabilité, ballonnements</li>
                  <li><strong>Conseil:</strong> Réduisez votre niveau de stress et augmentez le repos</li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>Comment utiliser la calculatrice de cycle menstruel</h3>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  Notre calculatrice vous aide à <strong>prédire vos prochaines périodes</strong> et à 
                  identifier vos jours fertiles:
                </p>
                <ol style={{ lineHeight: "1.8" }}>
                  <li><strong>Entrez la date du premier jour</strong> de votre dernière menstruation</li>
                  <li><strong>Entrez la durée de votre cycle</strong> (nombre de jours de votre cycle)</li>
                  <li>La calculatrice affichera vos <strong>prochaines dates de menstruation</strong></li>
                  <li>Elle montrera également votre <strong>fenêtre de fertilité</strong></li>
                  <li>Vous pouvez <strong>planifier</strong> ou <strong>prévenir</strong> la grossesse 
                  en conséquence</li>
                </ol>
                <p style={{ lineHeight: "1.8", marginTop: "15px" }}>
                  <strong>⚠️ Important:</strong> Cette calculatrice est à titre informatif. Pour un 
                  suivi médical précis, consultez un professionnel de santé.
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>Questions fréquemment posées sur le cycle menstruel</h3>
              </div>
              <div className="info-section-body">
                <h4 style={{ fontSize: "15px", marginTop: "10px", fontWeight: "bold" }}>
                  Q: Est-il normal d'avoir des cycles irréguliers?
                </h4>
                <p style={{ lineHeight: "1.8" }}>
                  R: Oui, les irrégularités occasionnelles sont normales. Cependant, si vos cycles 
                  sont très irréguliers pendant plusieurs mois, consultez un médecin.
                </p>

                <h4 style={{ fontSize: "15px", marginTop: "10px", fontWeight: "bold" }}>
                  Q: Puis-je devenir enceinte pendant ma menstruation?
                </h4>
                <p style={{ lineHeight: "1.8" }}>
                  R: C'est rare mais possible, surtout si vous avez un cycle court ou des 
                  irrégularités.
                </p>

                <h4 style={{ fontSize: "15px", marginTop: "10px", fontWeight: "bold" }}>
                  Q: Que faire si mon cycle est très douloureux?
                </h4>
                <p style={{ lineHeight: "1.8" }}>
                  R: Les douleurs légères sont normales, mais si elles sont intenses, consultez 
                  un professionnel de santé.
                </p>

                <h4 style={{ fontSize: "15px", marginTop: "10px", fontWeight: "bold" }}>
                  Q: Quel est le meilleur moment pour concevoir?
                </h4>
                <p style={{ lineHeight: "1.8" }}>
                  R: Les 5 jours avant l'ovulation et le jour de l'ovulation lui-même sont les 
                  jours les plus fertiles.
                </p>

                <h4 style={{ fontSize: "15px", marginTop: "10px", fontWeight: "bold" }}>
                  Q: Pourquoi mon cycle a-t-il changé?
                </h4>
                <p style={{ lineHeight: "1.8" }}>
                  R: Le stress, les changements de poids, l'exercice intense et les conditions 
                  médicales peuvent affecter votre cycle.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
    </div>
  );
}
export default PeriodCalculator;
